import { LineStyleOption } from './line-style-option.model';
import { LineStyle } from '../../modules/channel/models';

export class LineStyles {
	static List: Array<LineStyleOption> = [
		<LineStyleOption>{ lineStyle: LineStyle.Straight, label: '─────────' },
		<LineStyleOption>{ lineStyle: LineStyle.LongDash, label: '─ ─ ─ ─ ─ ─ ─' },
		<LineStyleOption>{ lineStyle: LineStyle.Dash, label: '– – – – – – –' },
		<LineStyleOption>{ lineStyle: LineStyle.DashedDot, label: '– · – · – · – · –' },
		<LineStyleOption>{ lineStyle: LineStyle.Dots, label: '· · · · · · · · · · · · · ·' },
	];
}
